import { AfterContentInit, Component, OnInit, ViewChild } from '@angular/core';
import { SpraViewDataComponent } from '../spra-view-data/spra-view-data.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentAgingParam } from "../../../Models/searchCustomer";
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { MasterService } from '../../../Services/master.service';
import { TransactionService } from '../../../Services/transaction.service';
import { SPRASerivceRequestData } from '../../../Models/ops';
import { NotificationService } from 'src/app/Services/notification.service';
import { HeaderService } from 'src/app/Services/header.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { Optional } from '@angular/core';
import { Shared } from 'src/app/Models/master';
declare var $: any;
@Component({
  selector: 'app-spra-view-ops',
  templateUrl: './spra-view-ops.component.html',
  styleUrls: ['./spra-view-ops.component.css']
})
export class SpraViewOpsComponent implements OnInit {

  @ViewChild(SpraViewDataComponent) SpraViewDataComponent!: SpraViewDataComponent;
  
  SPRAId: number = 0;
  RefId: number = 0;
  Header: number = 0;
  ProfitTag: boolean;
  IsForPriceRef:boolean;
  paymentAgingParam: PaymentAgingParam;
  utility: Utility;
  spraReqServiceDetail: SPRASerivceRequestData;
  param: any;
  public DistanceList: any[] = [];

  constructor(private router: Router,
    @Optional() public dialogRef: MatDialogRef<SpraViewOpsComponent>, //Added By rahul yadav on 
    @Optional() @Inject(MAT_DIALOG_DATA) public data:any,
    private _CookieService: CookieService,
    private _MasterService: MasterService,
    private _TransactionService:TransactionService,
    private _NotificationService:NotificationService,
    private route: ActivatedRoute, //Added By Rahul Yadav on 5/03/2021 for query string value
    private HeaderService: HeaderService //Added By Rahul Yadav on 5/03/2021 for header  value


   ) {
    this.utility = new Utility(this._CookieService);  
    this.ProfitTag=false;
    this.IsForPriceRef = false;
    this.spraReqServiceDetail = new SPRASerivceRequestData();
    this.paymentAgingParam = new PaymentAgingParam();
    this.param = this.router.getCurrentNavigation()?.extras.state;

    // ADDED BY RAJAN SINGH ON 06 JULY 2021 ->> WHEN OPENNING THE FROM REPORT IN NEW TAB
    this.route.params.subscribe( (params:any) =>{
      if(this.param == undefined && params && params.QueryParam != undefined){
        this.param =  JSON.parse(atob(params.QueryParam));
        this.HeaderService.emitChange(1);
      }
    });

   }
  
    
  ngOnInit(): void {
   
   this.route.queryParams.subscribe(params => {
     if(this.param == undefined && params){
      this.param=params;
    if(params.Header==1){      
      this.HeaderService.emitChange(params.Header);//Added By rahul yadav on 5/04/2021 To pass data to app component using header service to hide header menu
    }                                       //if we want to hide header menu then use Header service and pass json with Key "Header=1"
  }
  });
  }

  
  ngAfterContentInit() {    
//Added By Rahul Yadav on 5/03/2021 for query string value
if(this.data != undefined){
   this.SPRAId = this.data.SPRAId;
   this.RefId = this.data.RefId;
   this.IsForPriceRef = this.data.IsForPriceRef; 
   this.paymentAgingParam.saleCode  = this.data.salecode;
   this.paymentAgingParam.officeId =  parseInt(this.data.officeId);
   this.paymentAgingParam.CompanyId = this.data.CompanyID;
   if(this.data.ProfitTag!=undefined){
    this.ProfitTag = this.data.ProfitTag;
   }  
   
}
    
    if (this.param && this.data == undefined) {
      
      this.SPRAId = this.param.SPRAId;
      this.RefId = this.param.RefId;
      this.paymentAgingParam.saleCode  = this.param.salecode;
      this.paymentAgingParam.officeId =  parseInt(this.param.officeId);
      this.paymentAgingParam.CompanyId = this.param.CompanyID;
      //Added By Rahul Yadav on 13/07/2021 for query string value
      if(this.param.IsForPriceRef!=undefined ){
        this.IsForPriceRef = this.param.IsForPriceRef;
      }
      if(this.param.ProfitTag!=undefined ){
        this.ProfitTag = this.param.ProfitTag;
      }

    }
  }
}
